/**
 * The set of input field names for the email login UI component.
 */
export var EmailLoginFormInputField;
(function (EmailLoginFormInputField) {
    EmailLoginFormInputField["EMAIL"] = "email";
    EmailLoginFormInputField["PASSWORD"] = "password";
})(EmailLoginFormInputField || (EmailLoginFormInputField = {}));
